export default __webpack_public_path__ + "static/media/advent.12e2ce0b.png";